/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewclosingen4Inputs */

const en_letterpreviewclosingen4 = /** @type {(inputs: Letterpreviewclosingen4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I await your reply within one week, through the usual channels (message, email, or direct contact), so we can resolve this matter directly.`)
};

const pt_letterpreviewclosingen4 = /** @type {(inputs: Letterpreviewclosingen4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I await your reply within one week, through the usual channels (message, email, or direct contact), so we can resolve this matter directly.`)
};

/**
* | output |
* | --- |
* | "I await your reply within one week, through the usual channels (message, email, or direct contact), so we can resolve this matter directly." |
*
* @param {Letterpreviewclosingen4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewclosingen4 = /** @type {((inputs?: Letterpreviewclosingen4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewclosingen4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewclosingen4(inputs)
	return pt_letterpreviewclosingen4(inputs)
});
export { letterpreviewclosingen4 as "letterPreviewClosingEN" }